<template>
    <div class="form">
        <h4 class="step-title">
            <label for="VehicleModel">{{vehicle.make}} Vehicle Model</label>
        </h4>
        <ValidationObserver v-slot="{ errors, handleSubmit }" @submit.prevent>
            <div class="step-content d-flex flex-column align-items-center">
                <scrollable-button-list v-bind:items="models" v-bind:onclick="complete" v-if="models.length > 0"/>
                <div class="step-item" v-if="models.length == 0">
                    <ValidationProvider mode="eager" vid="vehicleModel" name="Vehicle model" rules="required">
                        <input id="vehicleModelText" class="form-control" type="text" v-on:keyup.enter="enterKeyup" v-model="vehicle.model">
                    </ValidationProvider>
                </div>
                <div class="step-item" v-if="errors['vehicleModel'] && errors['vehicleModel'].length > 0">
                    <div class="alert alert-danger">{{ errors["vehicleModel"][0] }}</div>
                </div>
                <div class="step-item" v-if="models.length == 0">
                    <button class="btn step-btn" ref="complete" v-on:click="handleSubmit(complete)">Continue</button>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import ScrollableButtonList from "./shared/ScrollableButtonList.vue"
    import { extend } from "vee-validate";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { required } from "vee-validate/dist/rules";

    extend("required", {
        ...required,
        message: "{_field_} is required."
    });

    export default {
        name: "VehicleModel",
        components: {
            ScrollableButtonList,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            lead: Object
        },
        data: function() {
            return {
                models: []
            }
        },
        created: function() {
            this.loadModels();
        },
        computed: {
            vehicle: function() {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            }
        },
        methods: {
            loadModels: function() {
                if (typeof window.AvengeDigitalWidgetYearMakeModelTrims !== "undefined") {

                    var models = this.models;
                    var modelsObject = window.AvengeDigitalWidgetYearMakeModelTrims[this.vehicle.year][this.vehicle.make];

                    Object.keys(modelsObject).forEach(function(key) {
                        models.push({ text: key, value: key });
                    });
                }
            },
            enterKeyup: function() {
                this.$refs.complete.click();
            },
            complete: function(vehicleModel) {
                if (vehicleModel) {
                    this.vehicle.model = vehicleModel;
                }

                this.$emit("complete", this.$options.name, this.vehicle.model);
            }
        }
    }
</script>
